import React from 'react';
import {
  NavigationContainer
} from './UbisoftPlusNavigationStyle';

const UbisoftPlusNavigation = () => {
  return (
    <NavigationContainer>
        <discover-components-navigation-bar
            theme='store'
            currentPage='cloud'
        ></discover-components-navigation-bar>
    </NavigationContainer>
  );
};

export default UbisoftPlusNavigation;